import {Project} from "@brg/api";

export const getPresentationImages = (project?: Project) => {

    // @ts-ignore
    if (!project || !['fixed-ratio-large', 'fixed-ratio-small', 't-shape']?.includes(project?.projectType)) return undefined;
    // @ts-ignore
    const presentationImages = JSON.parse(project?.additionalInfo?.presentationImages || "[]");
    return presentationImages?.length > 0 ? presentationImages : undefined;
}

export const getCourseImages = (project?: Project) => {
    // @ts-ignore
    const presentationImages = JSON.parse(project?.additionalInfo?.lmstitleimage || "[]");
    return presentationImages?.length > 0 ? presentationImages : undefined;
}import {Project} from "@brg/api";

export const getPresentationImages = (project?: Project) => {

    // @ts-ignore
    if (!project || !['fixed-ratio-large', 'fixed-ratio-small', 't-shape']?.includes(project?.projectType)) return undefined;
    // @ts-ignore
    const presentationImages = JSON.parse(project?.additionalInfo?.presentationImages || "[]");
    return presentationImages?.length > 0 ? presentationImages : undefined;
}

export const getCourseImages = (project?: Project) => {
    // @ts-ignore
    const presentationImages = JSON.parse(project?.additionalInfo?.lmstitleimage || "[]");
    return presentationImages?.length > 0 ? presentationImages : undefined;
}